import { setSafe } from "../../../util/storeHelper";
import * as actions from "../actions/session";
/**
 * reducer for changes to ephemeral session state
 */
export const sessionReducer = {
    reducers: {
        [actions.showCategoriesDialog]: (state, payload) => setSafe(state, ["showDialog"], payload),
    },
    defaults: {
        showDialog: false,
    },
};
